import { formatDate } from "../helpers";
import {

  Scissors,
  ShoppingBag,
} from "lucide-react";

export function HistorySection({ services, purchases }) {
  return (
    <div className="flex">
      <div className="w-full flex-1 pt-3">
        <p className="px-2 pb-2 mb-2 border-b border-gray-200 text-gray-800 font-semibold flex gap-1 items-center"><Scissors size={16} />Serviços</p>
        <ul className="divide-y divide-gray-100 bg-background flex-1 pr-1.5">
          {services.map((item, index) => (
            <li
              className="flex items-center justify-between gap-4 pl-4  pr-2 py-2"
              key={`${item.service}-${index}`}
            >
              <span className="text-sm font-medium text-gray-800">
                {item.service}
              </span>
              <span
                className={
                  item.date
                    ? "text-sm text-gray-600"
                    : "text-sm font-semibold text-gray-500"
                }
              >
                {formatDate(item.date)}
              </span>
            </li>
          ))}
        </ul>
      </div>
      <div className="w-full flex-1 pt-3">
        <p className="px-2 pb-2 mb-2 border-b border-gray-200 text-gray-800 font-semibold flex gap-1 items-center"><ShoppingBag size={16} />Produtos</p>
        <ul className="divide-y divide-gray-100 bg-background flex-1 pl-1.5">
          {purchases.map((item, index) => (
            <li
              className="flex items-center justify-between gap-4 pl-4  pr-2 py-2"
              key={`${item.item}-${index}`}
            >
              <span className="text-sm font-medium text-gray-800">
                {item.item}
              </span>
              <span
                className={
                  item.date
                    ? "text-sm text-gray-600"
                    : "text-sm font-semibold text-gray-500"
                }
              >
                {formatDate(item.date)}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
